import { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import UsersPage from "@/pages/UsersPage";
import GroupsPage from "@/pages/GroupsPage";
import RewardsPage from "@/pages/RewardsPage";
import ChannelsPage from "@/pages/ChannelsPage";
import MessagesPage from "@/pages/MessagesPage";
import SettingsPage from "@/pages/SettingsPage";
import Layout from "@/components/Layout";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [admin, setAdmin] = useState(null);

  const login = (t, a) => {
    localStorage.setItem("token", t);
    setToken(t);
    setAdmin(a);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setAdmin(null);
  };

  useEffect(() => {
    if (token && !admin) {
      const stored = localStorage.getItem("admin");
      if (stored) {
        try { setAdmin(JSON.parse(stored)); } catch {}
      }
    }
  }, [token, admin]);

  useEffect(() => {
    if (admin) {
      localStorage.setItem("admin", JSON.stringify(admin));
    }
  }, [admin]);

  return (
    <AuthContext.Provider value={{ token, admin, login, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={token ? <Navigate to="/" /> : <LoginPage />} />
          <Route element={token ? <Layout /> : <Navigate to="/login" />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="/rewards" element={<RewardsPage />} />
            <Route path="/channels" element={<ChannelsPage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthContext.Provider>
  );
}

export default App;
